const obj = {
    getDateNowText: () =>
    {
        const d = new Date();
        const y = d.getFullYear();
        const m = d.getMonth()+1;
        const day = d.getDay();

        return `${y}${m < 10 ? ('0'+m): m}${day < 10 ? ('0'+day): day}`;
    },
    
    fileNameNotiAdjustment_G: (mom_no)=>{
        return `ฉ.3 (พัสดุ) หนังสือแจ้งค่าปรับ_${mom_no}_${obj.getDateNowText()}`
    },
    fileNameNotiAdjustment_C: (mom_no)=>{
        return `(พาณิชย์) หนังสือแจ้งค่าปรับ_${mom_no}_${obj.getDateNowText()}`
    },
}

export default obj;